<template>
  <!-- School Condition and standard goes here -->
  <v-container fluid ma-0 pa-0 fill-height>
    <v-row justify="center" class="pa-1 ma-0">
      <v-col class="pa-0 ma-0">
        <v-text-field
          class="ttext my-1 px-1"
          outline
          hide-details
          v-model="sch_iden.declare_no"
          label="ប្រកាសលេខ"
        />
      </v-col>
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-text-field
          class="ttext my-1 px-1"
          outline
          placeholder="dd-mm-yyyy"
          :rules="[rules.declareDate]"
          v-model="sch_iden.declare_date"
          label="ចុះថ្ងៃ"
        />
      </v-col>
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-select
          class="px-1"
          v-model="sch_con.dt[0]"
          :items="schType"
          item-text="text"
          item-value="value"
          outline
          label="ប្រភេទសាលារៀន"
          hide-details
          @keypress.native="onSelect3($event, index)"
        >
        </v-select>
      </v-col>
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-select
          class="px-1"
          v-model="sch_con.dt[1]"
          :items="schCond"
          item-text="text"
          item-value="value"
          outline
          label="ស្ថានភាពសាលារៀន"
          hide-details
          @keypress.native="onSelect4($event, index)"
        >
        </v-select>
      </v-col>
      <!-- UTMX, UTMY block -->
      <v-col class="pa-0 ma-0">
        <v-text-field
          class="ttext my-1 px-1"
          outline
          hide-details
          v-model="infop.ux"
          type="number"
          label="UTM-X"
        />
      </v-col>
      <v-col class="pa-0 ma-0">
        <v-text-field
          class="ttext my-1 px-1"
          outline
          hide-details
          v-model="infop.uy"
          type="number"
          label="UTM-Y"
        />
      </v-col>
    </v-row>
    <v-divider class="pa-0 my-1"></v-divider>
    <v-row class="pa-0 ma-1">
      <v-col xs12 sm4 md4 class="pa-0 mx-1">
        <principle :data="sch_iden" :title="title[1]" />
      </v-col>
      <v-col xs12 sm4 md4 class="pa-0 mx-1">
        <schoolinfo :data="sch_iden" :title="title[2]" :info="infop" />
      </v-col>
      <!--
      <v-col xs12 sm4 md4 class="pa-0 mx-1">
        <incharge :data="sch_inch" :title="title[3]" />
      </v-col>
      -->
    </v-row>
  </v-container>
</template>

<script>
import schoolInfo from "@/components/ascf/pre/preSchoolInfo.vue";
import principle from "@/components/ascf/sharedCom/schoolPrinciple.vue";
//import incharge from "@/components/ascf/sharedCom/schoolIncharge.vue";
import { schType, schCond } from "@/utils/ascf/preConfig.js";

export default {
  props: ["title", "sch_con", "sch_inch", "sch_iden", "infop"],
  components: {
    schoolinfo: schoolInfo,
    principle: principle,
    //incharge: incharge,
  },
  data() {
    return {
      schType: schType,
      schCond: schCond,
      rules: {
        // :rules="[rules.required, rules.email]"
        required: (value) => !!value || "Required.",
        declareDate: (value) => {
          const pattern =
            /^(((((0[1-9])|(1\d)|(2[0-8]))-((0[1-9])|(1[0-2])))|((31-((0[13578])|(1[02])))|((29|30)-((0[1,3-9])|(1[0-2])))))-((20[0-9][0-9]))|(29-02-20(([02468][048])|([13579][26]))))$/;
          return pattern.test(value) || "សូមវាយទំរង់ dd-mm-yyyy";
        },
      },
    };
  },
  methods: {
    onSelect3: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 51) {
        this.sch_con.dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect4: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        this.sch_con.dt[1] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>